import React from "react";
import { IMediaCtaProps } from "./MediaCtaProps";
import { Banner, Container } from "./MediaCtaHelpers";
import Row from "../../global/Row/Row";
import Col from "../../global/Col/Col";

const MediaCta: React.FC<IMediaCtaProps> = (props) => {
  return (
    <Container>
      <Row>
        <Col className={`col6`}>
          <Banner {...props.node} />
        </Col>
        <Col className={`col6`}></Col>
      </Row>
    </Container>
  );
};

export default MediaCta;
